export default "__VITE_ASSET__CTRN$978__"